import type { FC } from "react";
import { featureFlags } from "src/lib/featureFlags";
import PrepareRefillDialogLegacy from "./PrepareRefillDialogLegacy";
import PrepareRefillDialogV2 from "./PrepareRefillDialogV2/PrepareRefillDialogV2";

/**
 * Entry point for the refill hub popup. Behind the `refillDecoupling` flag it renders
 * the score-free V2 hub (epic PROD-1264); otherwise the existing score-based hub.
 * Delete the legacy path once the flag is permanently on.
 */
const PrepareRefillDialog: FC<{ returnUrl: string }> = ({ returnUrl }) =>
  featureFlags.refillDecouplingEnabled ? (
    <PrepareRefillDialogV2 returnUrl={returnUrl} />
  ) : (
    <PrepareRefillDialogLegacy returnUrl={returnUrl} />
  );

export default PrepareRefillDialog;
